// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.app-info {
  padding: 20px 0 0 0;
  background: white;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
}
div.app-info tr {
  border-top: 1px solid #d8d9ea;
}
div.app-info tr td {
  text-align: center;
}
div.app-info th {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/applicant-info/applicant-info.component.less"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AALA;EAOQ,6BAAA;AACR;AARA;EASY,kBAAA;AAEZ;AAXA;EAaQ,kBAAA;AACR","sourcesContent":["@import (reference) url('../../../../assets/tables.less');\ndiv.app-info{\n    padding: 20px 0 0 0;\n    background: white;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.2;\n    tr{\n        border-top: 1px solid #d8d9ea;\n        td{\n            text-align: center;\n        }\n    }\n    th{\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
